import React from 'react'
import { useLanguage } from '../context/LanguageContext'
import { translations } from '../translations/translations'

export const T = ({ k }) => {
  const { language } = useLanguage()

  if (!k) return null

  // Get the translation or fallback to the key
  const translated = translations[language][k] || k

  // Process the text to handle **bold** formatting
  const processText = (text) => {
    if (typeof text !== 'string') return text

    // Split by **bold** pattern and create JSX elements
    const parts = text.split(/(\*\*.*?\*\*)/g)
    
    return parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        // Remove the ** markers and make it bold
        const boldText = part.slice(2, -2)
        return <strong key={index}>{boldText}</strong>
      }
      return part
    })
  }

  return <>{processText(translated)}</>
}
